(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["architectural-product-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.scrollMotionProductBannerLoaded) return;
    window.scrollMotionProductBannerLoaded = true;

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function lerp(start, end, progress) {
      return start + (end - start) * progress;
    }

    function easeInOutCubic(value) {
      return value < 0.5
        ? 4 * value * value * value
        : 1 - Math.pow(-2 * value + 2, 3) / 2;
    }

    function setCard(card, values) {
      card.style.setProperty('--smpb-x', values.x + 'px');
      card.style.setProperty('--smpb-y', values.y + 'px');
      card.style.setProperty('--smpb-scale', values.scale);
      card.style.setProperty('--smpb-rotate', values.rotate + 'deg');
      card.style.setProperty('--smpb-opacity', values.opacity);
      card.style.setProperty('--smpb-z', values.z);
      card.style.setProperty('--smpb-pointer', values.pointer ? 'auto' : 'none');
    }

    function initSection(section) {
      if (!section || section.dataset.smpbReady === 'true') return;

      section.dataset.smpbReady = 'true';

      var sticky = section.querySelector('.smpb__sticky');
      var cards = Array.prototype.slice.call(section.querySelectorAll('[data-smpb-card]'));

      if (!sticky || !cards.length) return;

      var state = {
        ticking: false,
        sectionTop: 0,
        sectionHeight: 0,
        stickyHeight: 0,
        viewportHeight: window.innerHeight,
        exitX: 0,
        exitY: 0,
        enterX: 0,
        enterY: 0
      };

      function measure() {
        var rect = section.getBoundingClientRect();

        state.sectionTop = rect.top + window.scrollY;
        state.sectionHeight = section.offsetHeight;
        state.stickyHeight = sticky.offsetHeight;
        state.viewportHeight = window.innerHeight;

        var isMobile = window.matchMedia('(max-width: 749px)').matches;

        state.exitX = isMobile ? window.innerWidth * 0.32 : window.innerWidth * 0.28;
        state.exitY = isMobile ? state.viewportHeight * 0.24 : state.viewportHeight * 0.22;

        state.enterX = isMobile ? -window.innerWidth * 0.36 : -window.innerWidth * 0.30;
        state.enterY = isMobile ? state.viewportHeight * 0.36 : state.viewportHeight * 0.34;
      }

      function update() {
        state.ticking = false;

        var total = cards.length;
        var maxIndex = total - 1;
        var scrollable = Math.max(1, state.sectionHeight - state.stickyHeight);
        var rawProgress = (window.scrollY - state.sectionTop) / scrollable;
        var progress = clamp(rawProgress, 0, 1);

        if (total === 1) {
          setCard(cards[0], {
            x: 0,
            y: 0,
            scale: 1,
            rotate: 0,
            opacity: 1,
            z: 5,
            pointer: true
          });
          return;
        }

        var rawIndex = progress * maxIndex;
        var currentIndex = Math.floor(rawIndex);
        var localProgress = rawIndex - currentIndex;

        if (currentIndex >= maxIndex) {
          currentIndex = maxIndex;
          localProgress = 0;
        }

        var nextIndex = Math.min(currentIndex + 1, maxIndex);
        var eased = easeInOutCubic(localProgress);

        cards.forEach(function (card, index) {
          var values = {
            x: state.enterX,
            y: state.enterY,
            scale: 0.7,
            rotate: -9,
            opacity: 0,
            z: 1,
            pointer: false
          };

          if (index === currentIndex) {
            values.x = lerp(0, state.exitX, eased);
            values.y = lerp(0, state.exitY, eased);
            values.scale = lerp(1, 0.72, eased);
            values.rotate = lerp(0, 9, eased);
            values.opacity = lerp(1, 0, eased);
            values.z = 4;
            values.pointer = localProgress < 0.45;
          }

          if (index === nextIndex && nextIndex !== currentIndex) {
            values.x = lerp(state.enterX, 0, eased);
            values.y = lerp(state.enterY, 0, eased);
            values.scale = lerp(0.72, 1, eased);
            values.rotate = lerp(-9, 0, eased);
            values.opacity = lerp(0, 1, eased);
            values.z = 5;
            values.pointer = localProgress >= 0.45;
          }

          if (progress === 1 && index === maxIndex) {
            values.x = 0;
            values.y = 0;
            values.scale = 1;
            values.rotate = 0;
            values.opacity = 1;
            values.z = 5;
            values.pointer = true;
          }

          setCard(card, values);
        });
      }

      function requestUpdate() {
        if (state.ticking) return;

        state.ticking = true;
        window.requestAnimationFrame(update);
      }

      measure();
      update();

      window.addEventListener('scroll', requestUpdate, { passive: true });

      window.addEventListener('resize', function () {
        measure();
        requestUpdate();
      });
    }

    function initAll(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('[data-smpb-section]');

      sections.forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
